import { render } from "./MentorProfileSettingsPage.vue?vue&type=template&id=58918c9e&scoped=true"
import script from "./MentorProfileSettingsPage.vue?vue&type=script&lang=js"
export * from "./MentorProfileSettingsPage.vue?vue&type=script&lang=js"

import "./MentorProfileSettingsPage.vue?vue&type=style&index=0&id=58918c9e&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58918c9e"]])

export default __exports__